module.exports = __webpack_public_path__ + "img/stepvan_stopped.a98e270b.svg";